import { IonButton, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, IonInput, IonSpinner } from "@ionic/react"
import Head from "../Header"
import Sidebar from "../Sidebar"
import DataTable from "react-data-table-component";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import service from "../../Service/service";
import swal from 'sweetalert';
import "../../theme/style2.css"
import { Modal } from "react-bootstrap";
import moment from "moment";

const ActivityCreateProject: React.FC = () => {

  const history = useHistory();
  const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));

  const [Id] = useState(localStorage.getItem("SignupEmpId"));
  const [data, setData] = useState([]);

  const [modalopen, setModalopen] = useState(false);

  const [filterText, setFilterText] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [isCheckboxSelected, setIsCheckboxSelected] = useState(false);
  const [lastCreatedProjectId, setLastCreatedProjectId] = useState("");
  const [selectedActivityCodes, setSelectedActivityCodes] = useState([]);

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [statusId,setStatusId] = useState([])

  const inputArr = [
    {
      activityCode: "",
      activityMeta: "",
      activityDescription: "",
      projectId: "",
      createdBy: "",
      parentActivityId: "",
    }
  ]
  const [activity, setActivity]: any = useState([inputArr])

  useEffect(() => {
    if (Id === null) {
      history.push("/login");
    }
  }, [Id, history]);

  useEffect(() => {
    LoadProject();
  }, []);

  const closemodal = () => {
    setModalopen(false);

  }
 //---------------- LoadProject Project --------------

 const LoadProject = () => {
  service.GetallProject(createdBy,statusId)
    .then((response) => {
      console.log("------->", response);
      if (response.data.status === 200) {
        setData([]);
      } else {
        const projects = response.data.Data;
        const lastProjectId = projects.length > 0 ? projects[projects.length - 1].id : "";
        setLastCreatedProjectId(lastProjectId);
        setData(projects);
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

// ------------ViewActivities-------------

const ViewActivities = (itm: any, Id: any) => {
  setModalopen(true);
  service.GetActivityCodeByProjectId(Id)
    .then((response) => {
      console.log("Activity List")
      console.log(response);
      if (response.status === 200) {
        setActivity(response.data.data)

      }
      else {
        setActivity([]);
      }
    });
}
// -----------Project Id and array of activity-------------

// const Projectidd = (e: any) => {
//   const selectedRows = e.selectedRows;
//   const selectedActivityCodes = selectedRows.map((row: any) => ({
//     activityCode: row.activityCode,
//     activityMeta: row.activityMeta,
//     activityDescription: row.activityDescription,
//     parentActivityId: row.parentActivityId,
//     createdBy: row.createdBy,
//   }));
//   console.log(selectedActivityCodes);
//   setSelectedActivityCodes(selectedActivityCodes);
// };
const Projectidd = (e: any) => {
  const selectedRows = e.selectedRows;
  const selectedActivityCodes = selectedRows.map((row: any) => ({
    activityCode: row.activityCode,
    activityMeta: row.activityMeta,
    activityDescription: row.activityDescription,
    parentActivityId: row.parentActivityId,
    createdBy: row.createdBy,
  }));
  console.log(selectedActivityCodes);
  setIsCheckboxSelected(selectedActivityCodes.length > 0);
  setSelectedActivityCodes(selectedActivityCodes);
};
// -------------- Assign Activity -------------

const Assignactivity = () => {
  if (!lastCreatedProjectId) {
    return;
  }
  if (!isCheckboxSelected) {
    swal("", "Select Actitvity To Assign.", "info");
    return;
  }
  service
  .ProjectInherit(lastCreatedProjectId, selectedActivityCodes, createdBy)
  .then((response) => {
    console.log("Response Data:", response.data);
    if (response.status === 200) {
      swal("", "Activities assigned successfully.", "success")
      .then(() => {
        setTimeout(() => {
          history.push("/HRProject");
        }, 0);
      });
    }
  });
};

  // --------------Datatable Activity  project list -------------

  const columns: any = [
    {
      name: "S.No",
      selector: (itm: any, i: any) => i + 1,
      sortable: true,
      // width: "70px",
    },
    {
      name: "Business Unit",
      selector: (itm: any) => itm.businessUnit.businessUnitName,
      cell: (itm: any) => {
        if (itm.businessUnit && itm.businessUnit.businessUnitName !== null && itm.businessUnit.businessUnitName !== undefined) {
          return itm.businessUnit.businessUnitName;
        } else {
          return 'NA';
        }
      },
      sortable: true,
      sort: "businessUnitName",
      width: "150px"
    },
    {
      name: "Department",
      selector: (itm: any) => itm.masterDepartment.departmentName,
      cell: (itm: any) => {
        if (itm.masterDepartment && itm.masterDepartment.departmentName !== null && itm.masterDepartment.departmentName !== undefined) {
          return itm.masterDepartment.departmentName;
        } else {
          return 'NA';
        }
      },
      sortable: true,
      sort: "departmentName",
      width: "270px"
    },
    {
      name: "Project Name",
      selector: (itm: any) => itm.projectName,
      sortable: true,
      width: "150px"
    },
    {
      name: "Created Date",
      selector: (itm: any) => itm.createdDate,
      sortable: true,
      sort: "createdDate",
      cell: (itm: any) => {
        var crDate = moment(itm.createdDate).format("DD-MM-YYYY")
        return (
          <>
            <IonText>{crDate}</IonText>
          </>
        )
      },
      width: "160px"
    },
  //   {
  //     name: "Status",
  //     // selector: (itm: any) => itm.projectStatus.status,
  //     sortable: true,
  //     width: "100px",
  //     cell: (itm: any) => (
  //         <div style={{ textAlign: 'center', verticalAlign: 'middle' }}>
  //             {itm.projectStatus.status === "Open" ? (
  //                 <p style={{ color: "#00b700", margin: '0' }}>Open</p>
  //             ) : itm.projectStatus.status === "Hold" ? (
  //                 <p style={{ color: "orange", margin: '0' }}>Hold</p>
  //             ) : (
  //                 <p style={{ color: "red", margin: '0' }}>Close</p>
  //             )}
  //         </div>

  //     )
  // },
    {
      name: "Action",
      sortable: false,
      cell: (itm: any) => (
        <>

          <IonText onClick={() => ViewActivities(itm, itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View Activities</IonText>

        </>
      )
    }
  ];

  // --------------Datatable View  Activity list -------------

  const ActivityListColumn: any = [
    {
      name: "S.No",
      selector: (itm: any, i: any) => i + 1,
      sortable: false,
      // width: "67px"
    },
    {
      name: "Activity Meta",
      selector: (itm: any) => itm.activityMeta,
      sortable: true,
      // width: "250px"
    },
    {
      name: "Activity Code",
      sortable: true,
      selector: (itm: any) => itm.activityCode,
      // width: "180px"
    },
    {
      name: "Activity Description",
      selector: (itm: any) => itm.activityDescription,
      sortable: true,
    },
  ]

  // -------------- customStyles for datatable-------------

  const customStyles = {
    headRow: {
      style: {
        // width:"100%"
      },
    },
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "15px",
        padding: "0px",
        justifyContent: "center"
      },
    },
    row: {
      style: {
      }
    },
    cells: {
      style: {
        fontSize: "16px",
        justifyContent: "center",
        padding: "0px"
      }
    }
  };


  const datatable = data.filter(
    (item: any) =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(filterText.toLowerCase()) !== -1
  );

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
  };
  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }

    };

    return (
      // ---------------datable search ----------------

      <div style={{ display: "flex" }}>
        <div style={{ display: "flex" }}>
          <div className="form-group form-focus row">
            <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
              value={filterText} placeholder="Search" />
            <label className="focus-label">Search</label>
          </div>
          <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
        </div>
      </div>
    )

  }, [filterText, resetPaginationToggle]);

 
  return (
    <IonPage>
      <Head />
      <Sidebar />
      <IonContent>
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title" style={{ fontWeight: "bold" }}>Activity</h3>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '2%' }} className="table-responsive">
            {/* -------------  Data table for Project yes view ------------- */}

            <DataTable
              columns={columns}
              data={datatable}
              pagination
              paginationPerPage={10}
              paginationComponentOptions={paginationComponentOptions}
              paginationRowsPerPageOptions={[10, 20, 30]}
              subHeader
              subHeaderComponent={subHeaderComponent}
              customStyles={customStyles}
            />
          </div>
          {/* -----------------View Activity modal-------------*/}
          <Modal
            dialogClassName="my-modal modal-dialog-centered"
            show={modalopen}>
            <div className="modal-header">
              <h5 className="modal-title">Assign Activity</h5>
              <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <DataTable
              columns={ActivityListColumn}
              data={activity}
              pagination
              paginationPerPage={10}
              paginationComponentOptions={paginationComponentOptions}
              paginationRowsPerPageOptions={[10, 20, 30]}
              selectableRows
              onSelectedRowsChange={Projectidd}
              subHeader
              subHeaderComponent={subHeaderComponent}
              customStyles={customStyles}
            />
            <div className="col-sm-6 col-md-3" style={{ alignSelf: 'center',paddingBottom:'10px'}}>
              <button onClick={Assignactivity} className="btn btn-orange btn-block w-100">
              Assign 
              </button>
            </div>
            {/* <div className="submit-section">
              <button onClick={Assignactivity} type="button" className="btn-primary submit-btn">Assign</button>
            </div> */}

          </Modal>
        </div>
      </IonContent>
    </IonPage>

  )
}
export default ActivityCreateProject;

